export * from "./checkCustomer";
export const API_URL_SEND_CODE = "/shop/api/checkout/sendcode";
export const API_URL_LOOKUP_CUSTOMER_BY_PHONE_NUMBER = `/shop/api/retailer/lookup`;
export const API_URL_CHECK_PHONE_NUMBER = "/shop/api/checkout/phonenumbercheck";
export const API_URL_CHECK_PHONE_NUMBER_FOR_NEW_MEMBER = "/shop/api/checkout/phonenumbercheckfornewmember";
export const API_URL_FETCH_PRICE_PLANS_FOR_SUBSCRIPTION = "/shop/api/checkout/priceplanforsubscription";
export const API_URL_EMPTY_ORDER = "/shop/api/checkout/emptyorder";
export const API_URL_CANCEL_PURCHASE = "/shop/api/checkout/cancelpurchase";
export const API_URL_RESET_ORDER = "/shop/api/checkout/resetorder";
export const API_URL_RESET_MEMBER = "/shop/api/checkout/resetmember";
export const API_URL_SET_DELIVERY_TYPE = "/shop/api/checkout/deliverytype";
export const API_URL_UPDATE_DELIVERY_ADDRESS = "/shop/api/checkout/updatedeliveryaddress";
export const API_URL_FIND_DELIVERY_ADDRESS = (address: string) =>
    `/shop/api/checkout/finddeliveryaddress?address=${address}`;
export const API_URL_FIND_DELIVERY_ADDRESS_GEONORGE = (address: string) =>
    `/shop/api/checkout/finddeliveryaddress-geonorge?address=${address}`;
export const API_URL_PAYMENT = "/shop/api/checkout/payment";
export const API_URL_PAYMENT_TYPE = "/shop/api/checkout/paymenttype";
export const API_URL_PRODUCT_USER = "/shop/api/checkout/productuser";
export const API_URL_CHECK_EMAIL_FOR_TELIA_TRYGG = "/shop/api/checkemail/trygg";
export const API_URL_CHECK_EMAIL_FOR_TELIA_SKY = "/shop/api/checkemail/sky";
export const API_URL_SUBMIT_INCOMPLETE_ORDER = "/shop/api/checkout/incompleteorder";
export const API_URL_UPDATE_PORTIN_DATE = "/shop/api/checkout/updateportindate";
